import { EpgProgram } from 'store/railsBuilder/reducer.types';

// good to cover this func by unit tests
export default function findProgramIndexForUpdate(
    channelId: string,
    data: Record<string, EpgProgram[]>,
    newData: Record<string, EpgProgram[]>,
) {
    const channel = data[channelId];

    let replaceFirstProgram = true;
    let replaceLastProgram = true;
    const first = channel[0];
    const firstStart = first.period.start;

    // find item with the same start or start in an item start-end range
    const startIndex = newData[channelId].findIndex((item) => {
        return (
            item.period.start === firstStart ||
            (item.period.start < firstStart && item.period.end >= firstStart)
        );
    });

    let closestStartIndex = 0;

    // if didn't find item index, find the closest item or set index as 0
    if (startIndex === -1) {
        replaceFirstProgram = false;
        closestStartIndex =
            newData[channelId]
                .sort((a, b) => b.period.end - a.period.end)
                .findIndex((item) => {
                    return item.period.end < firstStart;
                }) || 0;
    }

    const last = channel[channel.length - 1];
    const lastEnd = last.period.end;

    // the same logic as above but for end index
    const endIndex = newData[channelId].findIndex((item) => {
        return (
            item.period.end === lastEnd ||
            (item.period.start <= lastEnd && item.period.end > lastEnd)
        );
    });

    let closestEndIndex = 0;
    // the same logic as above but for end index
    if (endIndex === -1) {
        replaceLastProgram = false;
        closestEndIndex =
            newData[channelId].findIndex((item) => {
                return item.period.end > firstStart;
            }) || 0;
    }

    return {
        replaceFirstProgram,
        replaceLastProgram,
        startIndex: startIndex !== -1 ? startIndex : closestStartIndex,
        endIndex: endIndex !== -1 ? endIndex : closestEndIndex,
    };
}
